import { useEffect, useState } from "react";
import { useDashboard } from "../../../lib/useDashboard";
import { getInitialBoolean } from "@/shared/lib/localStorage";
import { MainTypesPlans } from "../../../model/dashboard.types";
import { useDashboardActions } from "../../../lib/useDashboardActions";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { CompanyResult } from "../../../model/dashboard.types";

const IS_PERIOD_KEY = "useDepartmentPlanById_isPeriod";

export function useDepartmentPlanById(departmentId: number | undefined) {
  const { dateStart, dateEnd } = useDashboard();
  const { getDepartmentsResult } = useDashboardActions();
  const { isAuth } = useAuth();

  const [isPeriod, setIsPeriod] = useState<boolean>(getInitialBoolean(IS_PERIOD_KEY, true));
  const [opportunity, setOpportunity] = useState<CompanyResult | null>(null);
  const [profit, setProfit] = useState<CompanyResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    localStorage.setItem(IS_PERIOD_KEY, String(isPeriod));
  }, [isPeriod]);

  useEffect(() => {
    if (!isAuth || !dateStart || !dateEnd || departmentId == null) return;

    const fetchAll = async () => {
      setLoading(true);
      setError(null);
      try {
        const [oppRes, profRes] = await Promise.all([
          getDepartmentsResult({
            dateStart,
            dateEnd,
            isPeriod,
            type: MainTypesPlans.opportunitie,
            departmentId,
          }),
          getDepartmentsResult({
            dateStart,
            dateEnd,
            isPeriod,
            type: MainTypesPlans.profit,
            departmentId,
          }),
        ]);
        setOpportunity(oppRes);
        setProfit(profRes);
      } catch {
        setError("Ошибка загрузки");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth, dateStart, dateEnd, isPeriod, departmentId]);

  return {
    opportunity,
    profit,
    loading,
    error,
    isPeriod,
    setIsPeriod,
  };
}
